<template>
  <div>
    <div class="header">
      <top-header></top-header>
    </div>
    <div class="con">
      <div class="tab">
        <left-tab></left-tab>
      </div>
      <div class="details">
        <router-view :key="key"></router-view>
      </div>
    </div>
  </div>
</template>

<script>
import leftTab from "../components/leftTab";
import topHeader from "../components/header";
export default {
  components: {
    leftTab,
    topHeader
  },
  computed: {
    key() {
      return this.$route.path;
    }
  },
  watch: {
    $route(val) {
      // console.log(val)
      // this.visivle=false;
      // this.visivle=true
    }
  },
  data() {
    return {
      // visivle:true
    };
  },
};
</script>

<style scoped>
.con {
  min-height: 50rem;
  display: flex;
  justify-content: left;
}
.tab {
  /* float: left; */
  /* width: 15rem; */
  min-height:50rem;
  background-color: rgb(240, 246, 246);
}
.details {
  flex-grow: 1;
  overflow: hidden;
  padding-top: 1rem;
  /* padding-right: 5rem; */
  margin-left: 1rem;
  animation: mys 0.5s;
}
@keyframes mys {
  0% {
    opacity: 0;
    margin-top: 20px;
  }
  100% {
    opacity: 1;
    margin-top: 0;
  }
}
</style>